import { Box, Step, StepLabel, Stepper } from '@mui/material';
import React, { FC } from 'react';
import { WizardPhase } from 'types/wizard';

const WizardPhaseOrder = {
	[WizardPhase.Build]: 0,
	[WizardPhase.Integrate]: 1,
	[WizardPhase.Customize]: 2,
	[WizardPhase.Done]: 3
};

interface IWizardTimelineProps {
	phase: `${WizardPhase}` | '';
}

const WizardTimeline: FC<IWizardTimelineProps> = ({ phase }) => {
	let current = WizardPhaseOrder[WizardPhase.Build];
	const steps = [
		WizardPhase.Build,
		WizardPhase.Integrate,
		WizardPhase.Customize
	].map((p) => {
		if (p === phase) {
			current = WizardPhaseOrder[p];
		}
		return {
			name: intl.tr(`wizard.phase.${p}`),
			completed: phase && WizardPhaseOrder[p] < WizardPhaseOrder[phase],
			current: p === phase
		};
	});

	return (
		<Box
			margin={{
				xs: '16px 0',
				sm: 'auto'
			}}
			data-testid="wizard-timeline"
			display="flex"
			flexDirection="column"
			justifyContent="space-between"
			flexGrow={1}
		>
			<Stepper activeStep={current}>
				{steps.map((step) => (
					<Step
						key={step.name}
						completed={!!step.completed}
						data-testid={`step-${step.name}`}
					>
						<StepLabel
							data-testid={`step-label-${step.name}`}
							sx={{
								textTransform: 'uppercase',
								wordBreak: 'break-all'
							}}
						>
							{step.name}
						</StepLabel>
					</Step>
				))}
			</Stepper>
		</Box>
	);
};

export default WizardTimeline;
